import { useState, useEffect } from "react";
import SEOHelmet from './SEOHelmet';
import Navbar from "./landing-page/Navbar";
import HeroSection from "./landing-page/HeroSection";
import AboutSection from "./landing-page/AboutSection";
import ModuleSection from "./landing-page/ModuleSection";
import FeaturesSection from "./landing-page/FeaturesSection";
import ContactSection from "./landing-page/ContactSection";
import BenefitsSection from "./landing-page/Benefits";
import SystemWorkingSection from "./landing-page/SystemWorkingSection";
import PlansSection from "./landing-page/PlansSection";
import ReviewSection from "./landing-page/ReviewSection";
import "../styles/LandingPage.css";

function HomePage() {
  // SEO is rendered at top of return
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "home", "about", "industries", "features",
        "benefits", "how-it-works", "reviews", "contact"
      ];
      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200 && rect.bottom >= 200) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="lp-page">
      <SEOHelmet page="home" canonicalUrl="https://www.assetflows.in/" />
      <Navbar setActiveSection={setActiveSection} activeSection={activeSection} />

      <HeroSection />
      <AboutSection />
      <ModuleSection />
      <FeaturesSection />
      <BenefitsSection />
      <SystemWorkingSection />
      <PlansSection />
      <ReviewSection />
      <ContactSection />

      {/* Footer */}
      <footer className="lp-footer">
        <div className="lp-footer__inner">
          <div className="lp-footer__brand">
            <h3>AssetFlows</h3>
            <p>Simple Asset Management for Every Team</p>
          </div>
          <div className="lp-footer__links">
            <a href="#home">Home</a>
            <a href="#about">About</a>
            <a href="#industries">Use Cases</a>
            <a href="#features">Features</a>
            <a href="#contact">Contact</a>
          </div>
          <div className="lp-footer__copy">
            &copy; {new Date().getFullYear()} Asset Manager. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;
